import composers from './composers/index';

const subjects = { composers };

export default subjects;
